import styled from 'styled-components'
import { theme } from 'styles/theme'
import cloudFooter from 'assets/svg/cloud_footer.svg'
import { getSize } from 'utils'

import BaseLayout from '../components/BaseLayout'
import { SportFigure, Quote, AuthorInfo, Footer } from '../components/BaseLayout/styled'

export const StyledLayoutLight = styled(BaseLayout)`
  grid-template-areas:
    'author-info'
    'quote';
  grid-template-rows: 0fr 1fr;
  grid-template-columns: 1fr;
  column-gap: 0;

  ${Footer} {
    display: block;
    background-image: url(${cloudFooter});
  }
  padding-top: ${getSize(70)};

  .background-image {
    mask-size: ${getSize(2072)} ${getSize(2072)};
    mask-position: ${getSize(-854)} ${getSize(-512)};
  }

  @media (max-aspect-ratio: 1/1) {
    padding-top: ${getSize(709)};

    .background-image {
      mask-size: ${getSize(2291)} ${getSize(2310)};
      mask-position: ${getSize(-332)} ${getSize(-34)};
    }
  }

  ${SportFigure} {
    display: none;
  }
  ${AuthorInfo} {
    .text-content {
      background-color: ${theme.colors.cloudPurple};
    }
  }

  ${Quote} {
    width: ${getSize(1570)};
    max-width: 100vw;
    top: -1px;
    border-top: 1px solid ${theme.colors.cloudPurple};

    svg {
      left: ${getSize(87)};
    }

    .quote {
      font-size: ${getSize(64)};
      line-height: ${getSize(74)};
      margin-left: ${getSize(200)};
      font-size: ${getSize(48)};
      line-height: ${getSize(58)};
      color: ${theme.colors.cloudPurple};

      -webkit-line-clamp: 6;
    }

    @media (max-aspect-ratio: 1/1) {
      height: ${getSize(710)};

      svg {
        left: ${getSize(87)};
      }

      .quote {
        font-size: ${getSize(61)};
        line-height: ${getSize(72)};
        -webkit-line-clamp: 9;
        margin-right: ${getSize(80)};
        margin-left: ${getSize(200)};
      }
    }
  }
`
export const StyledLayoutDark = styled(BaseLayout)`
  grid-template-areas:
    'author-info sport-figure'
    'quote sport-figure';
  grid-template-columns: ${getSize(1080)} 1fr;
  grid-template-rows: 0fr 1fr;

  .background-image {
    mask-size: ${getSize(2291)} ${getSize(2310)};
    mask-position: ${getSize(-721)} ${getSize(-784)};
  }
  ${AuthorInfo} {
    .text-content {
      background-color: ${theme.colors.neonPurple};
    }
  }
  ${Quote} {
    background-color: ${theme.colors.cloudPurple};
    svg {
      left: ${getSize(107)};
    }

    .quote {
      font-size: ${getSize(46)};
      line-height: ${getSize(62)};
      margin-left: ${getSize(107)};
      margin-right: ${getSize(30)};
      -webkit-line-clamp: 6;
      color: ${theme.colors.white};
    }

    @media (max-aspect-ratio: 1/1) {
      margin-right: ${getSize(80)};
      width: calc(100% - ${getSize(0)});
    }
  }

  @media (max-aspect-ratio: 1/1) {
    grid-template-columns: 1fr;
    grid-template-areas:
      'sport-figure'
      'author-info'
      'quote';
    grid-template-rows: ${getSize(786)} 0fr 0fr;

    .background-image {
      mask-size: ${getSize(2291)} ${getSize(2309)};
      mask-position: ${getSize(-332)} ${getSize(-34)};
      background-color: ${theme.colors.primaryBlack};
    }

    ${SportFigure} {
      margin-right: ${getSize(50)};

      text-align: left;
      margin-top: 0;
      margin-left: ${getSize(70)};
      max-width: calc(100% - ${getSize(120)});
    }

    ${AuthorInfo} {
      margin-top: ${getSize(33)};
      margin-right: ${getSize(170)};
    }
  }
`
